import Vue from 'vue'
import Vuex from 'vuex'

import emsCli from './modules/emsCli'
import wxSignature from './modules/wxSignature'
import addressInfo from './modules/addressInfo'
import consoleTips from './modules/consoleTips'
import freightMain from './modules/freightMain'
import user from './modules/user'
import protocol from './modules/protocol'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    emsCli,
    wxSignature,
    addressInfo,
    consoleTips,
    freightMain,
    user,
    protocol
  }
})
